import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'CloudMediate';
}



// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/app.component.ts